"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var core_1 = require("@emotion/core");
var react_bootstrap_1 = require("react-bootstrap");
var Button_1 = __importDefault(require("../button/Button"));
var card_1 = require("./card");
var LeftCard = /** @class */ (function (_super) {
    __extends(LeftCard, _super);
    function LeftCard(props) {
        return _super.call(this, props) || this;
    }
    LeftCard.prototype.render = function () {
        var _this = this;
        return (core_1.jsx(react_bootstrap_1.Card, { onClick: function (e) { return _this.onClick(e); }, css: this.cardStyling },
            core_1.jsx(react_bootstrap_1.Row, { css: this.rowStyling },
                this.props.imageSrc &&
                    core_1.jsx(react_bootstrap_1.Col, { sm: this.imageColSize, css: this.imageContainerStyling },
                        core_1.jsx(react_bootstrap_1.Card.Img, { src: this.props.imageSrc, css: this.imageStyling })),
                (this.props.title || this.props.children) &&
                    core_1.jsx(react_bootstrap_1.Col, { sm: this.contentColSize(), css: this.verticalAlignStyling },
                        core_1.jsx(react_bootstrap_1.Card.Body, { css: this.contentContainerStyling },
                            core_1.jsx("div", null,
                                this.props.title &&
                                    core_1.jsx(react_bootstrap_1.Card.Title, { css: this.titleStyling }, this.props.title),
                                this.props.children &&
                                    core_1.jsx("span", { css: this.contentStyling }, this.props.children)),
                            (this.props.onClick && this.props.linkTitle) &&
                                core_1.jsx("div", null,
                                    core_1.jsx(Button_1["default"], { buttonStyle: this.buttonStyling, onClick: function (e) { return _this.onClick(e); }, href: this.props.href }, this.props.linkTitle)))))));
    };
    return LeftCard;
}(card_1.HorizontalCard));
exports["default"] = LeftCard;
//# sourceMappingURL=LeftCard.js.map